import $ from 'jquery';
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'; // import the styles
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../util';
import { Line, Site } from './line.model';
import LineService from './line.service';

declare var window: WindowType;

@Component({
    name: 'line_component',
    components: {
        VueGoodTable
    },
})
export default class LineComponent extends Vue {
    service: LineService = new LineService();
    LinesPage: Line[] = [];
    selectedIndex: Line[] = [];
    newLine: Line = new Line();
    sites: Site[] = [];
    selectedSite: Site = new Site();
    isMaintenance: boolean = true;
    isEdit: boolean = false;

    columnsConfig = [
        {
            label: 'Name',
            field: 'name',
        },
        //{
        //    label: 'Id',
        //    field: 'id',
        //    type: 'number',
        //}
    ];
    selectConfig = {
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionText: this.getSelectionTextStr(),
        clearSelectionText: this.getClearStr(),
        disableSelectInfo: false, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    };

    constructor() {
        super();
        console.log("LineComponent");
        this.selectedIndex = [];
    }

    mounted() {
        this.isMaintenance = window.application.check2.isMaintenanceMode
        this.fetchSites();
        this.fetchLines();
    }

    fetchLines() {
        this.service.fetchLines()
            .then(data => {
                this.LinesPage = data as Line[];
                console.log(this.LinesPage);
            });
    }

    fetchSites() {
        //console.log("fetchsites");
        this.service.fetchSites()
            .then(data => {
                this.sites = data as Site[];
                console.log(this.sites);
            });
    }

    postLine() {
        console.log(this.newLine.id + ' ' + this.newLine.name + ' ' + this.newLine.id);
        if (!this.isEdit) {
            this.service.postLine(this.newLine);
        } else {
            this.service.updateLine(this.newLine);
        }
        this.isEdit = false;
        this.fetchAndClear();
    }

    deleteSelected() {
        if (this.selectedIndex.length > 0) {
            this.service.deleteLines(this.selectedIndex);
            this.fetchAndClear();
        }
    }

    editSelected() {
        $('#addModal').modal('show'); // caling jqery, be carefull with vue.js and  jqery
        if (this.selectedIndex.length > 0 && this.selectedIndex[0].id !== undefined) {
            this.newLine = this.selectedIndex[0];
            console.log(this.newLine);
            this.isEdit = true;
        }
    }

    clearSelection() {
        this.selectedIndex = [];
    }

    // Fetches the data after 1 second and also clears the inputs etc.s
    fetchAndClear() {
        // Create a new Promise and resolve after 1 seconds
        var myTimerPromise = new Promise((resolve, reject) => {
            setTimeout(resolve, 500);  // "resolve" is already a function, no need for another anonymous function here
        });

        // Fetch data now, within Promise.all()
        Promise.all([myTimerPromise]).then(() => {
            this.fetchSites();
            this.fetchLines();
            this.clearSelection();
            this.newLine = new Line();
        });
    }

    selectionChanged(params) {
        this.selectedIndex = params.selectedRows;
    }

    getClearStr() {
        return this.$i18n.t('comClear').toString();
    }

    getSelectionTextStr() {
        return this.$i18n.t('comSelectionCnt').toString();
    }
}